import * as a from "react";
const l = (e) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5 3a1 1 0 001 1h12a2 2 0 012 2v13a1 1 0 102 0V6a4 4 0 00-4-4H6a1 1 0 00-1 1zm0 3a3 3 0 00-3 3v10a3 3 0 003 3h10a3 3 0 003-3V9a3 3 0 00-3-3H5zM4 17.427V19a1 1 0 001 1h10a1 1 0 001-1v-1a.995.995 0 01-.608-.206l-2.24-1.716-1.106.677a2 2 0 01-2.37-.208l-2.471-2.188L4 17.427zm12-1.687V9a1 1 0 00-1-1H5a1 1 0 00-1 1v5.658l1.822-1.744a2 2 0 012.709-.052L11 15.05l1.106-.677a2 2 0 012.26.117L16 15.74zM12.5 12a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
      fill: "#2d6ded"
    }
  )
), t = l;
export {
  t as default
};
